module.exports = __webpack_public_path__ + "media/images/top_hf_scheme-d35f2972e41b3300e4667914078056c6.png";